import React, { useContext } from 'react';
import styles from './attachedWebDealLine.module.scss';
import { IconWrapper } from '../../../common/IconWrapper';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import ProductInformation from '../../../common/product-information/ProductInformation';
import UserContext from '../../../user/UserContext';

export default function AttachedWebDealLine({
    dealLine: {
        id,
        image,
        productCode,
        productDescription,
        unitSize,
        wasSellPrice,
        sellPrice,
        wasRSP,
        rsp,
        acceptedQuantity,
        margin,
        wasMargin,
        bestBefore
    }
}) {
    const { userDetails } = useContext(UserContext);
    const numberToPrice = numberField => {
        return '£' + numberField.toFixed(2);
    };

    const numberToPercentage = numberField => {
        return numberField.toFixed(2) + '%';
    };

    return (
        <>
            <tr className={`no-pointer ${styles.line}`}>
                <td>
                    <ProductInformation
                        url={window.CONFIG['ws.activoc-web-deals-public.lines.product.info.full']
                            .replace('{franchiseCode}', userDetails.currentFranchise.code)
                            .replace('{webDealLineId}', id)}
                        image={image}
                        description={productDescription}
                    />
                </td>
                <td>{productCode}</td>
                <td>
                    {productDescription}
                    <br />
                    {bestBefore && (
                        <span className={styles.bestBeforeInfo}>
                            <IconWrapper icon={faExclamationCircle} className={styles.bestBeforeIcon} />
                            BBE: {bestBefore}
                        </span>
                    )}
                </td>
                <td>{unitSize}</td>
                <td className={styles.doubles}>
                    {numberToPrice(sellPrice)} <br /> <span>{numberToPrice(wasSellPrice)}</span>
                </td>
                <td className={styles.doubles}>
                    {numberToPrice(rsp)} <br /> <span>{numberToPrice(wasRSP)}</span>
                </td>
                <td className={styles.doubles}>
                    {numberToPercentage(margin)} <br /> <span>{numberToPercentage(wasMargin)}</span>
                </td>
                <td>{acceptedQuantity}</td>
            </tr>
        </>
    );
}
